import { z } from 'zod';
import {
  BaseUUIDSearchSchema,
  ReferenceViewSchema,
  UUIDSchema,
  UUIDSearchSchema,
} from '../domain/models';
import { createPaginatedResponse } from '../domain/pagination';
import { PeriodSchema } from '../domain/schema';

export const PractitionerRoleSchema = z.object({
  id: UUIDSchema,
  active: z.boolean(),
  locations: ReferenceViewSchema.array().min(1),
  organization: ReferenceViewSchema,
  period: PeriodSchema,
  practitioner: ReferenceViewSchema,
});

export const GetPractitionerRolesInputSchema = z.object({
  practitioner: UUIDSearchSchema.optional(),
  organization: UUIDSearchSchema.optional(),
  location: UUIDSearchSchema.optional(),
});

export const GetPractitionerRolesByPractitionerInputSchema = z.object({
  id: UUIDSchema,
  organization: BaseUUIDSearchSchema.optional(),
  location: BaseUUIDSearchSchema.optional(),
});

export const GetPractitionerRolesResponseSchema = createPaginatedResponse(
  PractitionerRoleSchema,
);

export type PractitionerRole = z.infer<typeof PractitionerRoleSchema>;
export type GetPractitionerRolesInput = z.infer<
  typeof GetPractitionerRolesInputSchema
>;
export type GetPractitionerRolesResponse = z.infer<
  typeof GetPractitionerRolesResponseSchema
>;
export type GetPractitionerRolesByPractitionerInput = z.infer<
  typeof GetPractitionerRolesByPractitionerInputSchema
>;
